export default {
      id: "icon-phone-usage",
      viewBox: "0 0 31.619 32.824",
      url: __webpack_public_path__ + "icons.svg#icon-phone",
      toString: function () {
        return this.url;
      }
    }